import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';
import Select from 'react-select';
import {OptionsElement} from './../../../../Models/ViewManagementModel';

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    options: Array<OptionsElement>;
    wrapperClassName?: string;
    e2eId?: string
};

class SelectField extends React.PureComponent<WrappedFieldProps & Props> {
    public render() {
        const {input, meta, label, options, disabled, wrapperClassName} = this.props;
        let formClasses: string = 'form-field ';
        formClasses += meta.error && meta.touched ? ' form-field--error' : '';
        formClasses += wrapperClassName ? ` ${wrapperClassName} ` : '';
        formClasses += disabled ? ' form-field--disabled' : '';

        return (
            <div className={formClasses}>
                <label className="form-field__label" htmlFor={input.name}>{label}</label>
                <div date-e2eid={(this.props.e2eId) ? this.props.e2eId : null}>
                    <Select
                        id={input.name}
                        styles={
                            {
                                control: (styles) => ({
                                    ...styles,
                                    padding: '4px 2px'
                                }),
                                option: () => ({})
                            }
                        }
                        classNamePrefix={'form-control'}
                        value={input.value}
                        onChange={input.onChange}
                        onBlur={() => {
                            input.onBlur(input.value);
                        }}
                        options={options}
                        className="form-control"
                        isDisabled={disabled}
                        // defaultMenuIsOpen={true}
                        {...this.props}
                    />
                    {(meta.touched &&
                        (meta.error && (
                            <div className="form-field__error"
                                 date-e2eid={(this.props.e2eId) ? this.props.e2eId + "_error" : null}>
                                {meta.error}
                            </div>
                        ))) ||
                    (meta.warning && <span>{meta.warning}</span>)}
                </div>
            </div>
        );
    }
}

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/SelectField.tsx